import React from 'react';
import Loader from './Loader'
import Widget from '../Widget/Widget'

class LoaderWidget extends React.Component {
  render() {
    return (
      <Widget {...this.props}>
        <div className="row widget-fullheight-row">
          <div className="col align-self-center">
            <Loader/>
          </div>
        </div>
      </Widget>
    )
  }
}

export default LoaderWidget;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/Loader/LoaderWidget.js